<template>
  <div class="expense-list">
    <div class="expense-list-actions">
      <div class="expense-list-add" @click="openCreateModal">
        <i class="fa-regular fa-square-plus expense-list-add-icon"></i>
        <span>Despesa</span>
      </div>
    </div>

    <ModalChild
      v-model="showModal"
      title="Despesa"
      :width="750"
      body-padding="14px 16px"
      @close="onModalClose"
    >
      <ExpenseCreateUpdate
        :genericId="genericId"
        :value="selectedExpense"
        @saved="onSaved"
      />
    </ModalChild>

    <Loading v-if="loading" type="line" />

    <div v-if="expenses.length === 0 && !loading" class="expense-list-empty">
      <i class="fa-regular fa-file-invoice-dollar"></i>
      <span>Nenhuma despesa adicionada!</span>
    </div>

    <div v-else class="expense-list-items">
      <ExpenseRow
        v-for="item in expenses"
        :key="item.id"
        :item="item"
        :removing="isLoading(item.id)"
        @edit="openEditModal"
        @remove="removeExpense"
      />
    </div>
  </div>
</template>

<script>
import Loading from "@/ui/shared/Loading.vue";
import ModalChild from "@/ui/layout/ModalChild.vue";

import ExpenseCreateUpdate from "./ExpenseCreateUpdate.vue";
import ExpenseRow from "./ExpenseRow.vue";
import ExpenseService from "../services/expense.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ExpenseList",
  components: {
    Loading,
    ModalChild,
    ExpenseCreateUpdate,
    ExpenseRow,
  },
  props: {
    genericId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      expenses: [],
      showModal: false,
      selectedExpense: null,
    };
  },
  mounted() {
    this.loadAll();
  },
  computed: {
    ...mapGetters("generic", ["isLoading"]),
  },
  methods: {
    ...mapMutations("generic", ["addLoading", "removeLoading"]),
    async loadAll() {
      this.loading = true;
      try {
        const response = await ExpenseService.getAll(this.genericId);
        this.expenses = response.data.content.data || [];
        this.$emit("count-change", this.expenses.length);
      } finally {
        this.loading = false;
      }
    },
    openCreateModal() {
      this.selectedExpense = null;
      this.showModal = true;
    },
    openEditModal(item) {
      this.selectedExpense = item;
      this.showModal = true;
    },
    onModalClose() {
      this.selectedExpense = null;
    },
    async onSaved({ closeOnSave } = {}) {
      if (closeOnSave !== false) {
        this.showModal = false;
        this.selectedExpense = null;
      }
      await this.loadAll();
    },
    async removeExpense(item) {
      if (this.isLoading(item.id)) return;
      this.addLoading(item.id);
      try {
        await ExpenseService.remove(item.id);
        await this.loadAll();
      } finally {
        this.removeLoading([item.id]);
      }
    }
  },
};
</script>

<style scoped>
.expense-list-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.expense-list-add {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.expense-list-add:hover {
  background: var(--bg-hover);
}

.expense-list-add-icon {
  font-size: 16px;
  color: var(--text-muted);
}

.expense-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 0;
  color: var(--text-muted);
  font-size: 14px;
}

.expense-list-empty i {
  font-size: 32px;
}

.expense-list-items {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
